import * as React from "react";
import { forwardRef } from "react";
const SvgHelpOutlined = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 2a14 14 0 1 0 0 28 14 14 0 0 0 0-28Zm0 26a12 12 0 1 1 0-24 12 12 0 0 1 0 24Zm0-3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm-.5-17H17a4.5 4.5 0 1 1 0 9v2.5h-2V15h2a2.5 2.5 0 0 0 0-5h-1.5a2.5 2.5 0 0 0-2.5 2.5v.5h-2v-.5A4.49 4.49 0 0 1 15.5 8Z", fill: "#263238" }));
const ForwardRef = forwardRef(SvgHelpOutlined);
export { ForwardRef as ReactComponent };
